import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./Auth";

export const RequireAuth = ({ children }) => {
  //   const auth = useAuth();
  const location = useLocation();
  const state = useAuth();
  const [isLogin] = state.isLogin;

  if (!isLogin) {
    return <Navigate to="/login" state={{ path: location.pathname }} />;
  }

  return children;
};
